import { useAuthStore } from "./auth-store";
import { toast } from "@/lib/toast";

const REAUTH_REQUIRED_ERROR_CODES = new Set([
  "invalid_grant",
  "login_required",
  "consent_required",
  "missing_refresh_token",
]);

export function isReauthRequiredError(error: unknown): boolean {
  if (!error || typeof error !== "object") {
    return false;
  }

  const code = (error as { error?: unknown }).error;
  return typeof code === "string" && REAUTH_REQUIRED_ERROR_CODES.has(code);
}

let sessionExpiredHandled = false;

export function resetSessionExpiredGuard() {
  sessionExpiredHandled = false;
}

export function handleSessionExpired() {
  if (sessionExpiredHandled) {
    return;
  }
  sessionExpiredHandled = true;

  toast.warning("Session expired\nPlease sign in again to continue.");

  void useAuthStore
    .getState()
    .logout?.({ logoutParams: { returnTo: window.location.origin } });
}
